import { action, makeObservable, observable, runInAction } from 'mobx';
import { iocNames } from '../../iocNames';
import type { GqlService } from '../../services/GqlService';
import { subscribeUniversal } from '../../utils/subscribeUniversal';
import { GetIdeasDataDocument } from './getIdeasData.generated';
import type { EntityCache } from '../../services/EntityCache';
import { Idea, IIdea } from '../../models/Idea';
import type { IsUserAuthorized } from '../../services/isUserAuthorized';
import type { EventBus } from '../../services/EventBus';

// eslint-disable-next-line @typescript-eslint/no-unused-expressions
iocNames;

export interface IdeasDict {
  list: IIdea[] | undefined;
  getById(id: number): IIdea | undefined;
  isLoading: boolean;
  error: unknown;
}

export class IdeasStore implements IdeasDict {
  @observable
  public list: IIdea[] | undefined;

  @observable
  public isLoading = false;

  @observable
  public error: unknown;

  constructor(
    private gqlService: GqlService,
    private entityCache: EntityCache,
    getIsUserAuthorized: IsUserAuthorized,
    private eventBus: EventBus
  ) {
    makeObservable(this);

    subscribeUniversal(
      this,
      ['list', 'isLoading', 'error'],
      () => {
        this.updateIdeasData();
      },
      () => {
        runInAction(() => {
          this.list = undefined;
          this.isLoading = false;
          this.entityCache.clearEntities(Idea.name);
        });
      },
      getIsUserAuthorized
    );

    this.eventBus.listen(
      e => e.name === 'UserCardCreatedEvent',
      () => {
        this.updateIdeasData();
      }
    );
  }

  getById(id: number): IIdea | undefined {
    // позволяет срабатывать subscribeUniversal в случае если кто-то обратился за идеей
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.list;
    return this.entityCache.getEntityById(Idea.name, id);
  }

  @action
  public updateIdeasData = () => {
    this.isLoading = true;
    this.error = undefined;

    this.gqlService
      .makeRequest({
        requestOptions: {
          document: GetIdeasDataDocument
        },
        needAuthorization: true
      })
      .then(result => {
        runInAction(() => {
          this.list = this.entityCache.deserialize(
            Idea,
            result.dizraptor.ideas?.all
          ) as any as IIdea[];
        });
        return this.list as IIdea[];
      })
      .catch(err => {
        runInAction(() => {
          this.error = err;
        });
      })
      .finally(() => {
        runInAction(() => {
          this.isLoading = false;
        });
      });
  };
}
